<template>
    <div>
        <!-- start page title -->
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Dashboard</h4>
                </div>
            </div>
        </div>
        <br><br>
        <!-- end page title -->

        <div class="row grouped-multiple-statistics-card">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div
                                    class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon primary d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-bar-chart customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
<!--                                            ₦ {{ number_format($data['total_revenue']) }} -->
                                            900
                                        </h3>
                                        <p class="sub-heading">Total Revenue</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div
                                    class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon danger d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-users customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_patients }}
                                        </h3>
                                        <p class="sub-heading">Patients</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div class="d-flex align-items-start border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon success d-flex justify-content-center mr-3">
                                            <i class="fa p-1 fa-calendar customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                           800
                                        </h3>
                                        <p class="sub-heading">On going Appointments</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div class="d-flex align-items-start">
                                        <span class="card-icon warning d-flex justify-content-center mr-3">
                                            <i class="fa p-1 fa-heartbeat customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_HMOs }}
                                        </h3>
                                        <p class="sub-heading">HMO</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row grouped-multiple-statistics-card">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div
                                    class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon primary d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-home customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                          {{ total_hospitals }}
                                        </h3>
                                        <p class="sub-heading">Hospitals</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div
                                    class="d-flex align-items-start mb-sm-1 mb-xl-0 border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon danger d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-users customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_doctors }}
                                        </h3>
                                        <p class="sub-heading">Doctors</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div class="d-flex align-items-start border-right-blue-grey border-right-lighten-5">
                                        <span class="card-icon success d-flex justify-content-center mr-3">
                                            <i class="fa p-1 fa-building customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                            {{ total_diagnotics_center }}
                                        </h3>
                                        <p class="sub-heading">Diagnostics Center</p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-xl-3 col-sm-6 col-12">
                                <div class="d-flex align-items-start">
                                        <span class="card-icon warning d-flex justify-content-center mr-3">
                                            <i class="icon p-1 icon-basket-loaded customize-icon font-large-2 p-1"></i>
                                        </span>
                                    <div class="stats-amount mr-3">
                                        <h3 class="heading-text text-bold-600">
                                           900
                                        </h3>
                                        <p class="sub-heading">Orders</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
// import BarChart from "../ChartTemplate/BarChart";

export default {
    metaInfo: {title: 'Dashboard'},
    layout: Layout,
    // components: {
    //     BarChart
    // },
    props:[
        'total_users', 'total_hospitals', 'total_diagnotics_center', 'total_patients', 'total_doctors',
        'total_HMOs'
    ],

    data: () => ({}),
    mounted() {
        this.loaded = true
    },
    methods: {

     }
}
</script>
